import React from 'react';
import { Container, Tabs } from 'components';

const InstantScanEdit = () => {
  return (
    <Container.Tab>
      <Tabs />
    </Container.Tab>
  );
};

export default InstantScanEdit;
